module.exports = __webpack_public_path__ + "img/card.9e197ba8.jpg";